import React, { ReactElement } from 'react'
import Grid from '@mui/material/Grid'

type FilterWrapper = {
  children: ReactElement
}

const FilterWrapper = (props: FilterWrapper) => {
  const { children } = props
  return (
    <Grid spacing={2} sx={{ mt: 0 }} container direction="row">
      {children}
    </Grid>
  )
}

export default FilterWrapper
